import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GetBlogService from '../../api/Blogs/GetBlogs/GetBlogService';
import DeleteBlogService from '../../api/Blogs/DeleteBlog/deleteBlogService';
import { Blog } from './IBlog';
import { addBlogPath, editBlogPath } from '../../sitemap';
import { imagePath } from '../../context/constant';
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';

const BlogList = () => {
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(true);
  const [sortOption, setSortOption] = useState<string>('newest'); // Default sorting option
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = () => {
    setLoading(true);
    GetBlogService()
      .then((data: Blog[]) => setBlogs(data))
      .catch(err => {
        console.error(err);
        toast.error('Failed to load blogs');
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = async (id: string) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff4d4f',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        await DeleteBlogService(id);
        toast.success('Blog deleted successfully!');
        fetchBlogs();
      } catch (error) {
        console.error('Error deleting blog:', error);
        toast.error('Failed to delete blog.');
      }
    }
  };

  const sortBlogs = (blogs: Blog[]) => {
    switch (sortOption) {
      case 'a-to-z':
        return [...blogs].sort((a, b) => a.title.localeCompare(b.title));
      case 'z-to-a':
        return [...blogs].sort((a, b) => b.title.localeCompare(a.title));
      case 'newest':
        return [...blogs].sort((a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime());
      case 'oldest':
        return [...blogs].sort((a, b) => new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime());
      case 'modified':
        return [...blogs].sort((a, b) => new Date(b.updatedAt || 0).getTime() - new Date(a.updatedAt || 0).getTime());
      default:
        return blogs;
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <Toaster position="bottom-center" reverseOrder={false} />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <button
          onClick={() => navigate(addBlogPath())}
          style={{
            backgroundColor: '#ff7f50',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            padding: '0.5rem 1rem',
            cursor: 'pointer',
          }}
        >
          ➕ Add Blog
        </button>

        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          style={{
            padding: '0.5rem',
            borderRadius: '8px',
            border: '1px solid #ccc',
            cursor: 'pointer',
          }}
        >
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="a-to-z">A to Z</option>
          <option value="z-to-a">Z to A</option>
          <option value="modified">Modified Last</option>
        </select>
      </div>

      {loading ? (
        <p>Loading blogs...</p>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '1.5rem',
          }}
        >
          {sortBlogs(blogs).map((blog) => (
            <div
              key={blog._id}
              style={{
                border: '1px solid #f8dcdc',
                borderRadius: '12px',
                padding: '1rem',
                backgroundColor: '#fff5f5',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                cursor: 'pointer',
                position: 'relative',
              }}
              onClick={() => navigate(editBlogPath(blog._id))}
            >
              <img
                src={blog.thumbnail ? imagePath + blog.thumbnail : `${imagePath}placeholder_600x400.svg`}
                alt={blog.title || 'Blog thumbnail'}
                style={{
                  width: '100%',
                  height: '150px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  marginBottom: '0.5rem',
                }}
              />
              <h3 style={{ fontSize: '1.1rem', margin: '0.5rem 0' }}>{blog.title}</h3>
              <p style={{ margin: '0.25rem 0', color: '#333' }}>
                <strong>Author:</strong> {blog.author}
              </p>
              <p
                style={{ fontSize: '0.9rem', color: '#555' }}
                dangerouslySetInnerHTML={{
                  __html: blog.content.length > 100
                    ? blog.content.substring(0, 100) + '...'
                    : blog.content,
                }}
              ></p>
              <small style={{ color: '#999' }}>Tags: {blog.tags.join(', ')}</small>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(blog._id);
                }}
                style={{
                  position: 'absolute',
                  bottom: '15px',
                  right: '15px',
                  backgroundColor: '#ff4d4f',
                  border: 'none',
                  color: '#fff',
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px',
                  cursor: 'pointer',
                }}
                title="Delete Blog"
              >
                🗑️
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogList;